__turbopack_context__.v({
  "component": "style-module-scss-module__NObKQG__component",
  "exp-theme": "style-module-scss-module__NObKQG__exp-theme",
});
